import React, {useState} from 'react'
import Breadcrumb, {BreadcrumbType} from '../../components/Breadcrumb'
import {
  AssetsBox,
  AssetTitle,
  IconsBox,
  LeftBox,
  RightBox,
} from '../VideoPage/styles'
import {Link as RouterLink} from 'react-router-dom'
import AssetsSidenav from '../../components/AssetsSidenav'
import ProvenProcess from '../../../images/icons/new-dashboard/proven-process-icon.svg'
import {getDivisionDetails} from '../../../constants/divisions'
import {AssetDescription, ButtonBox} from './styles'
import {
  StudyGuide,
  StudyGuideAssets,
  StudyGuideStudyDays,
} from '../../../redux/studyGuides'
import {Helmet} from 'react-helmet'
import {Button} from '../../../components/button'
import {useNavigate} from 'react-router-dom'
import {SecondaryLinkButton} from '../../../styles/global'
import {useWindowDimensions} from '../../../hooks/useWindowDimensions'

type Props = {
  studyGuide?: StudyGuide
  studyDay?: string
  breakId?: string
  onSaveProgress: (value: number, studyDay: number) => void
}

const View = ({studyGuide, studyDay, breakId, onSaveProgress}: Props) => {
  const navigate = useNavigate()
  const {isMobile} = useWindowDimensions()

  const [isExpanded, setIsExpanded] = useState(isMobile ? false : true)

  const breadcrumbs: BreadcrumbType[] = [
    {
      title: studyGuide?.courseTitle ?? '',
      url: `/study-guide/${studyGuide?.id}`,
    },
    {
      title: `Day ${studyDay}`,
      url: `/study-guide/${studyGuide?.id}`,
    },
  ]

  const division = getDivisionDetails(studyGuide?.abbreviation ?? null)

  const currentAsset = studyGuide?.assets?.find(a => a.break)
  const sgBreak = currentAsset?.break[0]

  const handleSaveProgress = () => {
    if (sgBreak) {
      onSaveProgress(sgBreak.assetGlobalId, Number(studyDay))
    }
  }

  const goToNext = (url: string) => {
    if (sgBreak) {
      handleSaveProgress()
      navigate(url, {
        replace: true,
      })
    }
  }

  const nextDayAssets = studyGuide?.assets?.find(
    a => a.studyDay === (Number(studyDay) ?? 0) + 1,
  )

  const getUnifiedAssets = (assets?: StudyGuideStudyDays) => {
    return assets
      ? [
          ...(Array.isArray(assets.video) ? assets.video : []),
          ...(Array.isArray(assets.quiz) ? assets.quiz : []),
          ...(Array.isArray(assets.flashcard_deck)
            ? assets.flashcard_deck
            : []),
          ...(Array.isArray(assets.lecture_slides)
            ? assets.lecture_slides
            : []),
          ...(Array.isArray(assets.practice_exam) ? assets.practice_exam : []),
          ...(Array.isArray(assets.break) ? assets.break : []),
        ]
      : []
  }

  const getNextAssetUrl = (asset?: StudyGuideAssets) => {
    let type = ''

    if (asset) {
      switch (asset.assetType) {
        case 'video':
          type = 'videos'
          break
        case 'quiz':
          type = 'quizzes'
          break
        case 'flashcard_deck':
          type = 'flashcards'
          break
        case 'lecture_slides':
          type = 'slides'
          break
        case 'break':
          type = 'breaks'
          break
        case 'practice_exam':
          type = 'practice-exams'
          break
      }

      return type === 'slides'
        ? asset.downloadUrl ?? ''
        : `/study-guide/${studyGuide?.id}/${asset?.studyDay}/${type}/${asset?.id}`
    }

    return ''
  }

  const nextDayUnifiedAssets = getUnifiedAssets(nextDayAssets)

  return (
    <>
      <Helmet>
        <title>{`${sgBreak?.assetTitle} | Black Spectacles`}</title>
      </Helmet>
      <Breadcrumb breadcrumbs={breadcrumbs} />
      <AssetsBox>
        <LeftBox $isExpanded={isExpanded}>
          <AssetsSidenav
            currentAssetId={breakId}
            studyGuide={studyGuide}
            studyDay={Number(studyDay)}
            isExpanded={isExpanded}
            onChangeIsExpanded={(value: boolean) => setIsExpanded(value)}
          />
        </LeftBox>
        <RightBox>
          <IconsBox>
            <img src={division?.icon} alt={division?.name} />
            <img src={ProvenProcess} alt="Proven Process" />
          </IconsBox>
          <AssetTitle>{sgBreak?.assetTitle}</AssetTitle>
          <AssetDescription>
            Today is a study break, giving you a chance to review your notes and
            reinforce what you've learned so far. Use this time to reflect on
            key concepts and revisit any areas that need extra attention.
            <br />
            <br />
            If you're ready to move forward, you can jump to the next day by
            clicking the button below.
          </AssetDescription>
          <ButtonBox>
            {nextDayUnifiedAssets.length === 0 ? (
              <SecondaryLinkButton
                component={RouterLink}
                to={`/study-guide/${studyGuide?.id}`}
                onClick={handleSaveProgress}
              >
                Back go study guide
              </SecondaryLinkButton>
            ) : (
              <Button
                color="secondary"
                children={`Continue to Day ${(Number(studyDay) ?? 0) + 1}`}
                onClick={() =>
                  goToNext(getNextAssetUrl(nextDayUnifiedAssets[0]))
                }
              />
            )}
          </ButtonBox>
        </RightBox>
      </AssetsBox>
    </>
  )
}

export default View
